export const config = {
  title: "Ron Smith’s Fit for Life | Texarkana, TX",
  meta: {
    description:
      "Ron Smith’s Fit for Life offers personalized fitness programs in Texarkana, TX, including resistance training, martial arts-based cardio, and meal planning to help you achieve your health goals.",
    keywords: [
      "Ron Smith’s Fit for Life",
      "Texarkana Fitness",
      "Personal Training Texarkana",
      "Martial Arts Cardio",
      "Meal Planning Texarkana",
      "Resistance Training Texarkana",
    ],
    author: "Ron Smith’s Fit for Life",
    canonicalUrl: "https://ronsmithsfitforlife.com/",
  },
  sections: {
    header: {
      businessName: "Ron Smith’s Fit for Life",
    },
    sectionB: {
      heroTitle: "Achieve Your Fitness Goals with Ron Smith",
      heroSubtitle: "Personalized Training Programs in Texarkana, TX",
      learnAboutText: "Learn More",
      phoneNumber: "9039499554",
      phoneLabel: "(903) 949-9554",
      heroBackgroundImage:
        "https://ronsmithsfitforlife.com/wp-content/uploads/2025/04/header.jpg",
      cardData: [
        {
          title: "Resistance Training",
          description:
            "Build strength and endurance with customized weight training programs.",
        },
        {
          title: "Martial Arts-Based Cardio",
          description:
            "Enhance your cardiovascular health with engaging martial arts-inspired workouts.",
        },
        {
          title: "Meal Planning",
          description:
            "Receive personalized meal plans to complement your fitness journey.",
        },
      ],
      description:
        "At Ron Smith’s Fit for Life, we are dedicated to helping you achieve your health and fitness goals through tailored programs that fit your lifestyle.",
    },
    sectionC: {
      servicesTitle: "Our Services",
      servicesDescription:
        "Comprehensive fitness solutions designed to meet your individual needs.",
      cards: [
        {
          title: "Personal Training",
          description:
            "One-on-one sessions focused on your specific fitness objectives.",
          imageSrc: "https://ronsmithsfitforlife.com/wp-content/uploads/2025/04/Personal-Trainer.jpg",
          imageAlt: "Personal Training",
        },
        {
          title: "Group Classes",
          description:
            "Join our community in dynamic group workouts that motivate and inspire.",
          imageSrc: "https://media.istockphoto.com/id/2183730389/photo/people-doing-squats-with-female-trainer-holding-gymnastic-sticks-in-fitness-club.jpg?s=612x612&w=0&k=20&c=qWnVG6t_vM61IrvDz7XPvRo6KiBB-x7xgvW3RLY-ROA=",
          imageAlt: "Group Fitness Classes",
        },
        {
          title: "Nutrition Coaching",
          description:
            "Work with our experts to develop a nutrition plan that supports your fitness goals.",
          imageSrc: "https://media.istockphoto.com/id/1161751428/photo/portrait-of-young-smiling-female-nutritionist-in-the-consultation-room.jpg?s=612x612&w=0&k=20&c=TfjvD8vVq5-U87zIj71woSPpE2kZT09-FI4lTsqIKh8=",
          imageAlt: "Nutrition Coaching",
        },
      ],
      otherServicesTitle: "Additional Services",
      otherServicesList: [
        "Fitness Assessments",
        "Customized Workout Plans",
        "Lifestyle Coaching",
        "Weight Management Programs",
        "Flexibility and Mobility Training",
      ],
    },
    sectionD: {
      aboutTitle: "About Us",
      aboutImage: {
        src: "https://ronsmithsfitforlife.com/wp-content/uploads/2025/04/01.jpg",
        alt: "Ron Smith’s Fit for Life Team",
      },
      aboutText: [
        "Ron Smith’s Fit for Life is a premier fitness center in Texarkana, TX, committed to providing personalized training programs that empower individuals to achieve their health goals.",
        "With a focus on resistance training, martial arts-based cardio, and comprehensive meal planning, we offer a holistic approach to fitness that caters to all levels.",
      ],
    },
    sectionE: {
      profileImage: null, // Add profile image URL if available
      profileAlt: "Ron Smith’s Fit for Life Logo",
      businessName: "Ron Smith’s Fit for Life",
      contact: {
        phone: "9039499554",
        phoneLabel: "(903) 949-9554",
        email: "ronsfitforlife@gmail.com",
        website: "https://ronsmithsfitforlife.com/",
        address: "3505 Summerhill Rd Ste 18, Texarkana, TX 75503, United States",
      },
      socialMedia: {
        facebook: null,
        instagram: null, // Add Instagram URL if available
        twitter: null, // Add Twitter URL if available
        linkedIn: null, // Add LinkedIn URL if available
        youtube: null, // Add YouTube URL if available
      },
    },
    sectionF: {
      address: "3505 Summerhill Rd Ste 18, Texarkana, TX 75503, United States",
      googleMapsEmbedUrl:
        "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3349.123456789!2d-94.0665666!3d33.4513311!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8634c1234567890%3A0x123456789abcdef!2s3505%20Summerhill%20Rd%20Ste%2018%2C%20Texarkana%2C%20TX%2075503%2C%20USA!5e0!3m2!1sen!2sus!4v1611234567890!5m2!1sen!2sus",
    },
  },
};

export default config;
